jQuery(document).ready(function($) {
    // Code that uses jQuery's $ can follow here.

    window.addEventListener('DOMContentLoaded', (event) => {

	var hscreen = jQuery(window).height();
	jQuery('#wrapper-navbar.cdfMegaNav .navbar .nav-item.mobileMegaMenuDropdown > .dropdown-menu').height(hscreen);
	jQuery('#navbarNavDropdown').height(hscreen - 54);
	
	setTimeout(() => {
		jQuery('#navbar-toggler').click(function() {
			console.log('trigger first click');
			if(jQuery('html').hasClass('open-menu')){
				jQuery('html').removeClass('open-menu');
			}else{
				jQuery('html').addClass('open-menu');
			}
			if(jQuery(this).hasClass('open')){
				jQuery(this).removeClass('open');
			}else{
				jQuery(this).addClass('open');
			}
			jQuery('#navbarNavDropdown').toggleClass(function() {
				return jQuery(this).is('.slide-in, .slide-out') ? 'slide-in slide-out' : 'slide-in';
			})
		});
	}, 1000);
	
	setTimeout(() => {
	jQuery('.sc_fs_faq.sc_card').click(function() {
		jQuery('.sc_fs_faq.sc_card').removeClass('show');
		jQuery(this).addClass('show');
	});
	}, 1000);
	
	jQuery('.search-toggler').click(function () {
		jQuery('.search-container').addClass('open');
		if( !jQuery('html').hasClass('opendiv') ) {
			jQuery('html').addClass('opendiv');
		}
	});

	jQuery('.search-close').on('click', function () {
		jQuery('.search-container').removeClass('open');
	});

	jQuery('.btn-close-search').on('click',function(e) {
		jQuery('.search-container').removeClass('open');
		if( jQuery('html').hasClass('opendiv') ) {
			jQuery('html').removeClass('opendiv');
		}
		e.preventDefault();
	});

	jQuery('.nav-item > .dropdown-toggle').on('click', function(e) {
		e.preventDefault();
		jQuery('.nav-item').removeClass('active');
		jQuery('.nav-item > .dropdown-menu').removeClass('show');
		jQuery('.nav-item > .dropdown-toggle').not(jQuery(this)).attr('aria-expanded','false');

		if ( jQuery(this).attr('aria-expanded') == 'false' ) {
			jQuery(this).closest('.nav-item').addClass('active');
			jQuery(this).attr('aria-expanded','true');
			jQuery(this).siblings('.dropdown-menu').addClass('show');
			jQuery('.navbar-nav').addClass('has-menu-open');
		} else {
			jQuery(this).closest('.nav-item').removeClass('active');
			jQuery(this).attr('aria-expanded','false');
			jQuery(this).siblings('.dropdown-menu').removeClass('show');
			jQuery('.navbar-nav').removeClass('has-menu-open');
		}
		
	});
	
	jQuery('.item-submenu > .dropdown-toggle').click(function(e) {
		e.preventDefault();
	
		var jQuerythis = jQuery(this);
	   
		if ( jQuery(this).attr('aria-expanded') == 'true' ) {
			jQuery(this).attr('aria-expanded','false');
			jQuerythis.next().removeClass('show');
			jQuerythis.next().slideUp(350);
		} else {
			jQuery('.item-submenu').find('.dropdown-menu').removeClass('show');
			jQuery('.item-submenu').find('.dropdown-menu').slideUp(350);
			jQuery('.item-submenu').find('.dropdown-toggle').attr('aria-expanded','false');
			jQuery(this).attr('aria-expanded','true');
			jQuery(this).siblings('.dropdown-menu').addClass('show');
			jQuery(this).siblings('.dropdown-menu').slideDown(350);
		}
  });
  var normalNavTop = jQuery('#wrapper-navbar').height(); 
	var normalNav = function(){
		var scrollTop = jQuery(window).scrollTop();      
		if (scrollTop > normalNavTop) { 
			jQuery('#wrapper-navbar').addClass('sticky-header');
		} else {
			jQuery('#wrapper-navbar').removeClass('sticky-header');
		}
	};

	normalNav();
	jQuery(window).scroll(function() {
		normalNav();
	});
	var current = window.location.href;
	if ( current !== '/' ) {
		jQuery('#menu-top-menu li a').each(function(){
			var jQuerythis = jQuery(this);
			if( jQuerythis.attr('href') === current ){
				jQuerythis.addClass('active');
				jQuerythis.closest('li.c-megaMenu--menu-item').addClass('parent-active');
				jQuerythis.closest('.c-megaMenu--sub-menu .row > li').addClass('parent-sub-active');
			}
		});
	}
   
	jQuery('.c-megaMenu--normal-links > a').hover(function() {
		jQuery(this).toggleClass('hover');
		jQuery(this).closest('.c-megaMenu--sub-sub-menu').toggleClass('hover');
	});

	jQuery('.mobileMegaMenuDropdown > a.nav-link').on('click',function(e) {
		if (/#/.test(this.href)) {

			jQuery('.nav-item').removeClass('active');
			jQuery('.nav-item > .dropdown-menu').removeClass('show');
			
			if ( jQuery(this).siblings('.dropdown-toggle').attr('aria-expanded') == 'false' ) {
				jQuery('.nav-item > .dropdown-toggle').attr('aria-expanded','false');
				jQuery(this).parent().addClass('active');
				jQuery(this).siblings('.dropdown-toggle').attr('aria-expanded','true');
				jQuery(this).siblings('.dropdown-menu').addClass('show');
				jQuery('.navbar-nav').addClass('has-menu-open');
			} else {
				jQuery(this).parent().removeClass('active');
				jQuery(this).siblings('.dropdown-toggle').attr('aria-expanded','false');
				jQuery(this).siblings('.dropdown-menu').removeClass('show');
				jQuery('.navbar-nav').removeClass('has-menu-open');
			}

			e.preventDefault();
		}
	});
	jQuery('.item-submenu > .c-megaMenu--heading').on('click',function(e) {
		if (/#/.test(this.href)) {
			if ( jQuery(this).siblings('.dropdown-toggle').attr('aria-expanded') == 'true' ) {
				jQuery(this).siblings('.dropdown-toggle').attr('aria-expanded','false');
				jQuery(this).siblings('.dropdown-menu').removeClass('show');
				jQuery(this).siblings('.dropdown-menu').slideUp(350);
			} else {
				jQuery('.item-submenu').find('.dropdown-menu').removeClass('show');
				jQuery('.item-submenu').find('.dropdown-menu').slideUp(350);
				jQuery('.item-submenu').find('.dropdown-toggle').attr('aria-expanded','false');
				jQuery(this).siblings('.dropdown-toggle').attr('aria-expanded','true');
				jQuery(this).siblings('.dropdown-menu').addClass('show');
				jQuery(this).siblings('.dropdown-menu').slideDown(350);
			}

			e.preventDefault();
		}
	});


});

jQuery(function () {
    'use strict';

    // Accordion icon animation
    jQuery('.card-header a').on('click', function(e) {
        // Stop bootstrap function call from firing
        e.preventDefault();
        // Get this card Icon
        var circleIcon = jQuery(this).siblings('.icon-container').find('.circle-plus');
        // Remove open class from all other card icons
        jQuery('.circle-plus').not(circleIcon).removeClass('opened');
        // Fire bootstrap function 'collapse' manually
        jQuery(this).parent().siblings('.collapse').collapse('toggle');
        // Toggle class of icon to init css transition
        circleIcon.toggleClass('opened');
    });

    // Accordion icon collapse trigger
    jQuery('.card-header .icon-container').on('click', function() {
        // Get this card Icon
        var circleIcon = jQuery(this).find('.circle-plus');
        // Remove open class from all other card icons
        jQuery('.circle-plus').not(circleIcon).removeClass('opened');
        // Fire bootstrap function 'collapse' manually
        jQuery(this).parent().siblings('.collapse').collapse('toggle');
        // Toggle class of icon to init css transition
        circleIcon.toggleClass('opened');
    });

});

function checkScreenSize() {
    var newWindowWidth = jQuery(window).width(),
        mobile = false;

    if (newWindowWidth < 992) {
        mobile = true;
    }

    mobileFooter(mobile);
}

function mobileFooter(mobile) {
    var footerContainer = '.footer-container',
        footerMenu = '.footer-menu',
        footerMenuCount = jQuery(footerMenu).length,
        count = 1;

    while (count < footerMenuCount) {
        jQuery(footerMenu).each(function() {
            jQuery(this).addClass('footer-menu-' + count);

            if (mobile === true) {
                jQuery(footerContainer)
                    .removeClass('desktop-footer')
                    .addClass('mobile-footer');
                jQuery(footerContainer + ' > .footer-inner')
                    .removeClass('row row-eq-height no-gutters');
            } else {
                jQuery(footerContainer)
                    .addClass('desktop-footer')
                    .removeClass('mobile-footer');

                jQuery(footerContainer + ' > .footer-inner')
                    .addClass('row row-eq-height no-gutters')
                    .removeClass('accordion');

                jQuery(footerMenu)
                    .removeClass('card')
                    .addClass('col');

                jQuery(footerMenu + '.footer-menu-' + count).find('.widget-title')
                    .removeClass('card-header')
                    .removeAttr('id');
                jQuery(footerMenu + '.footer-menu-' + count)
                    .find('.widget-title > div')
                    .removeClass("mobile-acc-trigger collapsed")
                    .removeAttr("data-toggle")
                    .removeAttr("data-target")
                    .removeAttr("aria-controls");
                jQuery(footerMenu + '.footer-menu-' + count)
                    .find('.menu-footer-' + count + '-container')
                    .removeClass("collapse")
                    .removeAttr("id")
                    .removeAttr("aria-labelledby")
                    .removeAttr("data-parent");
            }

            count++;
        });
    }
}
//Gets all currency symbols from openexchangerates api
//Populate select box on successfull response
function getCurrencies() {
    var endpoint = 'https://openexchangerates.org/api/currencies.json';
    jQuery.ajax({
        url: endpoint,
        type: 'GET',
        success: function (response) {
            populateCurrenciesSelect(response);
        },
        error: function (message, status) {
            console.log('Get Currencies Error');
            console.log(message);
        }
    });
}
//Gets all crypto coins from cryptocompare api
//Populate select box on successfull response
function getCryptoCoins() {
    var apiKey = 'afcfd1aced000347d0234c00422cdc0588a1e9dc702d03d78d24e7fd393ae0e9';
    var endpoint = 'https://min-api.cryptocompare.com/data/all/coinlist?api_key=' + apiKey;
    jQuery.ajax({
        url: endpoint,
        type: 'GET',
        success: function (response) {
            populateCryptoCoinsSelect(response.Data);
        },
        error: function (message, status) {
            console.log('Get Crypto Coins Error');
            console.log(message);
        }
    });
}
//Populates cryptocoin select box with coin data
function populateCryptoCoinsSelect(coinData) {
    var defaultCoin = jQuery('.c-CryptoCurrencyConverter--form').find('.js-default-coin').val();;
    jQuery.each(coinData, function (key, val) {
        var option = new Option(val.Name, val.Symbol);
        //Adds selected attribute to default coin
        if (defaultCoin == val.Name) {
            option.setAttribute('selected', 'selected');
        }
        jQuery('.js-crypto-coins-select').append(jQuery(option));
    });
    var cryptoCoinsSelectBox = new jQuery.customSelect(jQuery('#CryptoCurrencyConverterCoins'));
    //Call function to hide form loader
    hideFormLoader();

}
//Populates currency select box with cureency data
function populateCurrenciesSelect(currencyData) {
    var defaultCurrency = jQuery('.c-CryptoCurrencyConverter--form').find('.js-default-currency').val();
    jQuery.each(currencyData, function (key, val) {
        var option = new Option(key, key);
        //Adds selected attribute to default currency code
        if (defaultCurrency == key) {
            option.setAttribute('selected', 'selected');
        }
        jQuery('.js-crypto-currency-select').append(jQuery(option));
    });
    convertCryptoCurrencies();
    var currencySelectBox = new jQuery.customSelect(jQuery('#CryptoCurrencyConverterCurrency'));
}
//Gets latest cryptocoin price based on the selected coin and currency.
//Calculates coin price on successful response
function convertCryptoCurrencies() {
    var selectedCoin = jQuery('.c-CryptoCurrencyConverter--form').find('.js-crypto-coins-select');
    var selectedCoinValue = jQuery('.c-CryptoCurrencyConverter--form').find('.js-crypto-coin-value-input');
    var selectedCurrency = jQuery('.c-CryptoCurrencyConverter--form').find('.js-crypto-currency-select');
    var selectedCurrencyValue = jQuery('.c-CryptoCurrencyConverter--form').find('.js-currency-value-input');
    var defaultCoin = jQuery('.c-CryptoCurrencyConverter--form').find('.js-default-coin');
    if(jQuery(selectedCoin).val() == null) {
        selectedCoin = defaultCoin;
    }
    var apiKey = 'afcfd1aced000347d0234c00422cdc0588a1e9dc702d03d78d24e7fd393ae0e9';
    var endpoint = 'https://min-api.cryptocompare.com/data/price?fsym=' + jQuery(selectedCoin).val() + '&tsyms=' + jQuery(selectedCurrency).val() + '&api_key=' + apiKey;
    jQuery.ajax({
        url: endpoint,
        type: 'GET',
        success: function (response) {
            //Call function to calculate the coin price
            calculateCoinPrice(response, selectedCoinValue, selectedCurrencyValue);
        },
        error: function (message, status) {
            console.log('Get Crypto Coin Price Error');
            console.log(message);
        }
    });
}
//Calculates the coin price based on coin amount, selected coin and currency
function calculateCoinPrice(priceData, selectedCoinValue, currencyValueInput) {
    //Display error message on error response
    if (typeof(priceData.Response) != 'undefined') {
        jQuery(currencyValueInput).parent().parent().find('.c-CryptoCurrencyConverter--form--error').text('Error: Currency not available.');
        jQuery(currencyValueInput).val(0);
        //Call function to hide form loader
        hideFormLoader();
        return false;
    }
    //Remove error message if visible
    jQuery(currencyValueInput).parent().parent().find('.c-CryptoCurrencyConverter--form--error').text('');
    //Coin price per coin
    var coinPrice = priceData[Object.keys(priceData)[0]];
    //Coin quantity
    var coinValue = parseFloat(jQuery(selectedCoinValue).val());
    //Multiplies coin quantity by coin price
    var price = coinValue.toFixed(2) * coinPrice;
    //Adds price to input value
    jQuery(currencyValueInput).val(price.toFixed(2));
}
//Shows Form loader and hides calculator form
function showFormLoader() {
    var formCalculator = jQuery('.c-CryptoCurrencyConverter--form--calculator');
    var formLoader = jQuery('.c-CryptoCurrencyConverter--form--loader');
    jQuery(formCalculator).hide();
    jQuery(formLoader).fadeIn();
}
//Hides form loader and shows form calculator
function hideFormLoader() {
    var formCalculator = jQuery('.c-CryptoCurrencyConverter--form--calculator');
    var formLoader = jQuery('.c-CryptoCurrencyConverter--form--loader');
    jQuery(formCalculator).fadeIn();
    jQuery(formLoader).hide();
}

jQuery(window).resize( function() {
    checkScreenSize();
});

jQuery(document).ready(function() {
    checkScreenSize();
    //Checks if crypto currency converter is visible on page
    if (jQuery('.c-CryptoCurrencyConverter').length > 0) {
        showFormLoader();
        //Get coins from api
        getCryptoCoins();
        //Get currencies from api
        getCurrencies();
    }
});


var formSubmission = (function(jQuery) {
    'use strict';

    // Validation Types
    var alphabetic = 0,
        alphabeticRule = /^[a-zA-Z\- '`]+jQuery/i, // with some special characters
        alphanumeric = 1,
        alphanumericRule = /^[\w\-/&.£:,+'()\s]+jQuery/i, // with some special characters
        email = 2,
        emailRule = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))jQuery/;

    // Validation Rules
    function validateField(selector, type, emptyAllowed) {
        if (typeof emptyAllowed == 'undefined') {
            emptyAllowed = false;
        }
        var element = jQuery(selector);
        if (element.length == 0) {
            return false;
        }
        var value = element.val();
        if (emptyAllowed === true) {
            if (value === null || value === '') {
                return true;
            }
        }
        // Is the field empty?
        if (value === null || value === '') {
            return false;
        }
        switch (type) {
            case alphabetic:
                if (!alphabeticRule.test(value)) {
                    return false;
                }
                break;
            case alphanumeric:
                if (!alphanumericRule.test(value)) {
                    return false;
                }
                break;
            case email:
                if (!emailRule.test(value)) {
                    return false;
                }
                break;
            case telephone:
                if (!telephoneRule.test(value)) {
                    return false;
                }
                break;
            default:
                break;
        }
        return true;
    }

    function formValidation(formContainer) {
        var inputEmail = jQuery('#' + formContainer + ' input[name=email]');

        jQuery('.form-group').find('.val-form-error').hide();
        jQuery('.form-group').removeClass('error');

        var error = false;
        if (!validateField(inputEmail, email, false)) {
            inputEmail.siblings('.val-form-error').show().html('Email is not valid');
            inputEmail.parent('.form-group').removeClass('valid').addClass('error');
            jQuery('#' + formContainer).find('.form-submit').removeClass('loading').removeAttr("disabled");
            error = true;
        } else {
            inputEmail.parent('.form-group').addClass('valid').removeClass('error');
        }
        if (error) {
            return;
        }
        formSubmit(formContainer);
    }

    function formSubmit(formContainer) {
        var form = jQuery('#' + formContainer),
            formData = form.serialize();

        jQuery.ajax({
            url: form.attr('action'),
            type: 'POST',
            data: formData,
            success: function (response) {
                var jsonResponse = JSON.parse(response),
                    status = jsonResponse.status,
                    message = jsonResponse.message,
                    error = jsonResponse.error;
                if (status === 'SUCCESS') {
                    form.find('.form-submit').removeClass('loading').addClass('success');
                    window.setTimeout(function () {
                        jQuery('#' + formContainer).hide();
                        jQuery('.c-signUp--successMessage').show();
                    }, 500);
                } else {
                    console.log(error);
                    form.find('.form-submit').siblings('.val-form-error').show().html(message);
                    form.find('.form-submit').removeClass('loading success').removeAttr("disabled");
                }
            },
            error: function (message, status) {
                console.log(status);
                form.find('.form-submit').siblings('.val-form-error').show().html(message);
                form.find('.form-submit').removeClass('loading success').removeAttr("disabled");
            }
        });
    }

    jQuery('button.form-submit').on('click', function(e) {
        e.preventDefault();
        jQuery(this).addClass('loading').attr("disabled", "disabled");
        var formContainer = jQuery(this).parent().parent().parent().attr('id');

        formValidation(formContainer);
    });
});

(function(jQuery) {
    'use strict';

    jQuery(document).ready(function() {
        formSubmission(jQuery);
    });
})(jQuery);

//Exchange list shortcode view more list
//********************************************

jQuery(document).ready(function () {
    'use strict';

    //Exchange list shortcode view more
    jQuery('.view-more-button').unbind('click').bind('click', function (e) {
        e.preventDefault();
        // Get List Count set in trigger
        var listSort = jQuery(this).attr('data-sortby');
        var listCount = jQuery(this).attr('data-count');
        // Get Offset Count set in trigger
        var offset = jQuery(this).attr('data-offset');
        var type = jQuery(this).attr('data-type');
        var website = "leaen";
        // Fire List function passing through list count and offset count
        var brokerIds = exchange_list_obj.brokerIds;
        var brokers = 'null';
        if (brokerIds != null) {
            var offsetSum = parseInt(offset) + parseInt(listCount);
            brokers = brokerIds.split(',').slice(offset, offsetSum);
            brokers = brokers.toString();
        }

        exchangeList(brokers, listSort, listCount, offset, type, website);

    });

    jQuery('.c-ExchangeList--more-trigger').unbind('click').bind('click', function (e) {
        e.preventDefault();
        viewMoreExchangeList(jQuery(this));
    });

});

//Show details accordion option
function viewMoreExchangeList(elem) {
    var container = elem.siblings('.c-ExchangeList--more-details--container');

    container.toggleClass('open');
    elem.toggleClass('open');
    var text = container.hasClass('open') ? jQuery('.less-label').html() : jQuery('.more-label').html();
    jQuery('.more-label').text(text);
}

//After click view more
//Exchange list shortcode run the this js/html
function exchangeList(brokers, sortby, listCount, offset, type, language) {
    if (brokers != 'null' && brokers != '' && brokers != ' ') {
        var endPoint = 'https://data.fin.com/index.php/wp-json/platform/v1/brokers/' + brokers;
    } else {
        var endPoint = 'https://data.fin.com/index.php/wp-json/platform/v1/sortby/' + sortby + '/count/' + listCount + '/offset/' + offset + '/type/' + type + '/language/' + language;
    }

    var returnCount = 0;
    var brokerCount = jQuery('.broker-num-count').attr('data-return');
    jQuery.ajax({
        url: endPoint,
        type: 'GET',
        success: function (response) {
            jQuery.each(response, function (i, item) {
                var type_array = item.type;
                jQuery.each(type_array, function (t, type) {
                    if (exchange_list_obj.listType === type) {
                        var newEndPoint = 'https://data.fin.com/index.php/wp-json/wp/v2/platformobject/' + item.id;
                        jQuery.ajax({
                            url: newEndPoint,
                            type: 'GET',
                            success: function (newResponse) {
                                var json_array = newResponse.acf,
                                    json_array_general = json_array.general.general_info,
                                    json_array_crypto = json_array.crypto,
                                    json_array_stocks = json_array.stocks,
                                    json_array_trading_forex = json_array.trading_forex;

                                var exchangeTitle = json_array.exchange_object_name,
                                    exchangeLogo = json_array_general.exchange_object_logo_url,
                                    starRating = parseInt(json_array.rating),
                                    ratingPercentage = Math.floor((starRating / 5) * 100),
                                    more_coins_text = json_array_crypto.crypto_info.exchange_object_total_number_of_coins,
                                    language_array = json_array.platform_objects,
                                    withdrawals_array = json_array.general.payment_and_withdrawals.exchange_object_payment_withdrawals_options;

                                jQuery.each(language_array, function (i, language) {
                                    var platformLanguage = language.languages;

                                    if (platformLanguage === 'kryde') {

                                        var disclaimer_text = language.text_translation_objects[0].exchange_objects_disclaimer,
                                            fullReviewLink = language.text_translation_objects[0].site_review_url,
                                            prosText1 = language.text_translation_objects[0].exchange_general_fee_pros_1,
                                            prosText2 = language.text_translation_objects[0].exchange_general_fee_pros_2,
                                            prosText3 = language.text_translation_objects[0].exchange_general_fee_pros_3,
                                            prosText4 = language.text_translation_objects[0].exchange_general_fee_pros_4,
                                            prosText5 = language.text_translation_objects[0].exchange_general_fee_pros_5;

                                        if(type === 'stock') {
                                            var companyLink = language.text_translation_objects[0].exchange_general_stock_company_link;
                                        } else if(type === 'crypto') {
                                            var companyLink = language.text_translation_objects[0].exchange_general_crypto_company_link;
                                        } else if(type === 'forex') {
                                            var companyLink = language.text_translation_objects[0].exchange_general_forex_company_link;
                                        }

                                        var platformOutput = '';
                                        platformOutput += '<div class="row fc-row">';
                                        platformOutput += '<div class="col-12">';
                                        platformOutput += '<div class="c-ExchangeIntro" id="exchange-intro">';
                                        if (json_array.preferred_broker === true) {
                                            platformOutput += '<div class="recommended-label">' + exchange_list_obj.recommendedLabel + '</div>';
                                        }
                                        platformOutput += '<div class="row">';
                                        platformOutput += '<div class="col-sm-6">';
                                        platformOutput += '<h2 class="c-ExchangeIntro--title"><span class="broker-count">' + brokerCount + '</span> ' + exchangeTitle + '</h2> ';
                                        platformOutput += '</div>';
                                        platformOutput += '<div class="col-sm-6">';
                                        platformOutput += '<div class="rating-holder">';
                                        platformOutput += '<p class="rating--text">' + exchange_list_obj.ratingLabel + '</p>';
                                        platformOutput += '<div class="rating--star-container">';
                                        platformOutput += '<div class="rating--star" style="width: ' + ratingPercentage + '%;"></div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';

                                        platformOutput += '<div class="row">';
                                        platformOutput += '<span class="c-ExchangeIntro--border"></span>';
                                        platformOutput += '</div>';

                                        platformOutput += '<div class="row">';
                                        platformOutput += '<div class="col-12 col-md-3 company-logo-column">';
                                        platformOutput += '<div class="company--logo">';
                                        platformOutput += '<img src="' + exchangeLogo  + '"class="company--logo-image" alt="">';
                                        platformOutput += '<div class="link-container">';
                                        platformOutput += '<a href="' + companyLink + '" target="_blank" class="d-inline-block d-md-none btn btn-primary">' + exchange_list_obj.buyCoinCTA + '</a>';
                                        platformOutput += '<a href="' + fullReviewLink + '" target="_blank" class="btn btn-ghost">' + exchange_list_obj.partnerCTA + '</a>';
                                        platformOutput += '<a href="' + companyLink + '" target="_blank" class="btn btn-ghost comparison-modal" href="#" data-exchange-id="' + item.id + '" data-toggle="modal" data-target="#compare_exchange_modal">' + exchange_list_obj.compareLabel + '</a>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '<div class="col-12 col-md-3">';
                                        if (prosText1) {
                                            platformOutput += '<div class="c-ExchangeIntro-sections">';
                                            platformOutput += '<p class="c-ExchangeIntro-title">' + exchange_list_obj.prosLabel + '</p>';
                                            platformOutput += '<ul class="pros--list">';
                                            if (prosText1) {
                                                platformOutput += '<li class="pros--text"><i class="fa fa-check"></i>' + prosText1 + '</li>';
                                            }
                                            if (prosText2) {
                                                platformOutput += '<li class="pros--text"><i class="fa fa-check"></i>' + prosText2 + '</li>';
                                            }
                                            if (prosText3) {
                                                platformOutput += '<li class="pros--text"><i class="fa fa-check"></i>' + prosText3 + '</li>';
                                            }
                                            if (prosText4) {
                                                platformOutput += '<li class="pros--text"><i class="fa fa-check"></i>' + prosText4 + '</li>';
                                            }
                                            if (prosText5) {
                                                platformOutput += '<li class="pros--text"><i class="fa fa-check"></i>' + prosText5 + '</li>';
                                            }
                                            platformOutput += '</ul>';
                                            platformOutput += '</div>';
                                        }
                                        platformOutput += '</div>';
                                        if (exchange_list_obj.listType === 'crypto') {
                                            platformOutput += '<div class="col-12 col-md-3 order-md-2">';
                                            var coin_array = json_array.crypto.crypto_info.exchange_object_coin_logos;
                                            if (coin_array) {
                                                platformOutput += '<div class="c-ExchangeIntro-sections">';
                                                platformOutput += '<p class="c-ExchangeIntro-title">' + exchange_list_obj.coinsLabel + '</p>';
                                                platformOutput += '<ul class="c-ExchangeIntro--coin-list">';
                                                jQuery.each(coin_array, function (c, coin) {
                                                    var coinTitle = coin.exchange_object_coin_name;
                                                    //var coinURL = '/wp-content/themes/understrap-child/assets/img/coin_icons/';
                                                    var coinImage = coin.exchange_object_coin_logos_url;
                                                    platformOutput += '<li class="c-ExchangeIntro--coin-item"><img src="' + coinImage + '" class="c-ExchangeIntro--coin-images" alt="' + coinTitle + '"></li>';
                                                });
                                                platformOutput += '</ul>';
                                                platformOutput += '<p class="more-coins">' + more_coins_text + ' ' + exchange_list_obj.totalCoinsLabel + '</p>';
                                                platformOutput += '<a href="' + companyLink + '" target="_blank" class="d-none d-md-inline-block btn btn-primary">' + exchange_list_obj.buyCoinCTA + '</a>';
                                                platformOutput += '</div>';
                                            }
                                            platformOutput += '</div>';
                                        } else if (exchange_list_obj.listType === 'stock') {
                                            platformOutput += '<div class="col-12 col-md-2 order-md-1">';
                                            var accountInfo = json_array.stocks.account_information;
                                            if (accountInfo) {
                                                platformOutput += '<div class="c-ExchangeIntro-sections stocks">';
                                                jQuery.each(accountInfo, function (key, item) {
                                                    if (key != 'exchange_object_finance_rates' && item != null && item != '') {
                                                        var keyLabel = key.replace(/exchange_object_/gi, "");
                                                        var keyLabel = keyLabel.replace(/_/gi, " ");

                                                        jQuery.each(exchange_list_obj.stockInfoArray, function (arrayKey, arrayItem) {
                                                            if (arrayKey === keyLabel) {
                                                                keyLabel = arrayItem;
                                                            }
                                                        });

                                                        platformOutput += '<p class="c-ExchangeIntro-title">' + keyLabel + '</p>';
                                                        platformOutput += '<ul class="pros--list fa-ul">';
                                                        platformOutput += '<li class="pros--text pl-0">' + item + '</li>';
                                                        platformOutput += '</ul>';
                                                    }
                                                });
                                                platformOutput += '</div>';
                                            }
                                            platformOutput += '</div>';
                                        } else if (exchange_list_obj.listType === 'forex') {
                                            platformOutput += '<div class="col-12 col-md-2 order-md-1">';

                                            var platForms = json_array.trading_forex.platform_overview.platforms;
                                            var foundedYear = json_array_general.exchange_object_founded;

                                            if (platForms) {
                                                platformOutput += '<div class="c-ExchangeIntro-sections stocks">';
                                                platformOutput += '<p class="c-ExchangeIntro-title">' + exchange_list_obj.platFormOption + '</p>';
                                                platformOutput += '<div class="pros--text pl-0 mt-2">';
                                                var loopOut = [];
                                                var separator = ', ';
                                                jQuery.each(platForms, function (p, platf) {
                                                    loopOut += platf;
                                                    if (!platf.length - 1) {
                                                        loopOut += separator;
                                                    }
                                                });
                                                platformOutput += loopOut;
                                                platformOutput += '</div>';
                                                platformOutput += '<p class="c-ExchangeIntro-title">' + exchange_list_obj.foundedOption + '</p>';
                                                platformOutput += '<div class="pros--text pl-0 mt-2">' + foundedYear + '</div>';
                                                platformOutput += '</div>';
                                            }
                                            platformOutput += '</div>';
                                        }
                                        if (exchange_list_obj.listType === 'crypto'){
                                            platformOutput += '<div class="col-12 col-md-2 order-md-1">';
                                        }else{
                                            platformOutput += '<div class="col-12 col-md-3 order-md-1">';
                                        }

                                        if (withdrawals_array) {
                                            platformOutput += '<div class="c-ExchangeIntro-sections">';
                                            platformOutput += '<p class="c-ExchangeIntro-title">' + exchange_list_obj.withdrawalsLabel + '</p>';
                                            platformOutput += '<ul class="pros--list d-none d-md-inline-block">';
                                            jQuery.each(withdrawals_array, function (w, withdrawals) {
                                                platformOutput += '<li class="pros--text pl-0">' + withdrawals.label + '</li>';
                                            });
                                            platformOutput += '</ul>';

                                            platformOutput += '<div class="pros--text pl-0 d-inline-block d-md-none">';
                                            jQuery.each(withdrawals_array, function (w, withdrawals) {
                                                platformOutput += withdrawals.label + ', ';
                                            });
                                            platformOutput += '</div>';
                                            platformOutput += '</div>';

                                            if (exchange_list_obj.listType === 'stock') {
                                                platformOutput += '<a href="' + companyLink + '" target="_blank" class="d-none d-md-inline-block btn btn-primary">' + exchange_list_obj.stockBuyCoinCTA + '</a>';
                                            }else if(exchange_list_obj.listType === 'forex'){
                                                platformOutput += '<a href="' + companyLink + '" target="_blank" class="d-none d-md-inline-block btn btn-primary">' + exchange_list_obj.forexBuyCoinCTA + '</a>';
                                            }
                                        }

                                        platformOutput += '</div>';
                                        platformOutput += '</div>';

                                        platformOutput += '<div class="row">';
                                        platformOutput += '<div class="col">';
                                        platformOutput += '<p class="c-ExchangeIntro--disclaimer-text">' + disclaimer_text + '</p>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';

                                        platformOutput += '<div class="row">';
                                        platformOutput += '<div class="col">';
                                        platformOutput += '<div class="c-ExchangeList--more">';
                                        platformOutput += '<a class="c-ExchangeList--more-trigger" onClick="viewMoreExchangeList(jQuery(this))"><span class="more-label">' + exchange_list_obj.showToggle + '</span></a>';
                                        platformOutput += '<div class="c-ExchangeList--more-details--container">';
                                        platformOutput += '<div class="row">';
                                        platformOutput += '<div class="col-12 col-md-4">';
                                        platformOutput += '<p class="c-ExchangeIntro-title">' + exchange_list_obj.accountInfoLabel + '</p>';
                                        platformOutput += '<div class="c-ExchangeList--more-details--accountInformation">';

                                        var type_array = json_array;

                                        if (exchange_list_obj.listType === 'crypto') {
                                            type_array = json_array_crypto.account_information;
                                        } else if (exchange_list_obj.listType === 'stock') {
                                            type_array = json_array_stocks.assets;
                                        } else if (exchange_list_obj.listType === 'forex') {
                                            type_array = json_array_trading_forex.account_information;
                                        }

                                        jQuery.each(type_array, function (key, item) {
                                            if (item != null && item != '') {
                                                // var keyLabel = key.replace(/_/gi, " ");
                                                keyLabel = key.replace(/exchange_object_/gi, "");
                                                keyLabel = keyLabel.replace(/forex_/gi, "");

                                                jQuery.each(exchange_list_obj.columnInputArray, function (arrayKey, arrayItem) {
                                                    if (arrayKey === keyLabel) {
                                                        keyLabel = arrayItem;
                                                    }
                                                });

                                                platformOutput += '<div class="c-ExchangeList--more-details--accountInformation-item">';
                                                platformOutput += '<span class="key">' + keyLabel + '</span>';
                                                platformOutput += '<span class="value">';
                                                if (item === 'yes' || item === true) {
                                                    platformOutput += '<img src="../wp-content/themes/understrap-child/assets/img/check.svg" />';
                                                } else if (item === 'no' || item === false) {
                                                    platformOutput += '<img src="../wp-content/themes/understrap-child/assets/img/cross.svg" />';
                                                } else if (jQuery.isArray(item)) {
                                                    platformOutput += item.join(", ");
                                                } else {
                                                    platformOutput += item;
                                                }
                                                platformOutput += '</span>';
                                                platformOutput += '</div>';
                                            }
                                        });
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';

                                        platformOutput += '<div class="col-12 col-md-4">';
                                        platformOutput += '<h3 class="c-ExchangeList--more-details--fees-title c-ExchangeIntro-title">' + exchange_list_obj.feesLabel + '</h3>';
                                        platformOutput += '<div class="c-ExchangeList--more-details--fees">';

                                        if (exchange_list_obj.listType === 'crypto') {
                                            type_array = json_array_crypto.crypto_fees;
                                        } else if (exchange_list_obj.listType === 'stock') {
                                            type_array = json_array_stocks.stocks_fees;
                                        } else if (exchange_list_obj.listType === 'forex') {
                                            type_array = json_array_trading_forex.spreads;
                                        }

                                        jQuery.each(type_array, function (key, item) {
                                            if (item.length && item != null && item != '') {
                                                var keyLabel = key.replace(/_/gi, " ");
                                                keyLabel = keyLabel.replace(/exchange object /gi, " ");
                                                keyLabel = keyLabel.replace(/Platform/gi, " ");
                                                keyLabel = keyLabel.replace(/-/gi, "/");
                                                var regexReplace = new RegExp(exchange_list_obj.listType + ' fee', 'gi');
                                                keyLabel = keyLabel.replace(regexReplace, " ");

                                                platformOutput += '<div class="c-ExchangeList--more-details--fees-item">';
                                                platformOutput += '<span class="key">' + keyLabel + '</span>';
                                                platformOutput += '<span class="value">' + item + '</span>';
                                                platformOutput += '</div>';
                                            }
                                        });
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';
                                        platformOutput += '</div>';

                                        jQuery('.more-platforms').append(platformOutput);

                                        returnCount++;
                                        jQuery('.return-count').attr('data-return', returnCount);

                                        brokerCount++;
                                    }
                                });

                                jQuery('.broker-num-count').attr('data-return', brokerCount);
                            },
                            error: function (newMessage) {
                                console.log('message : ' + newMessage);
                            }
                        });
                    }
                });
            });
        },
        error: function (message) {
            jQuery('.view-more-button').hide();
        }
    });


    var totalBrokers = jQuery('.total-brokers').attr('data-return'),
        brokerCountRemaining = jQuery('.broker-count-remaining'),
        initialCount = jQuery('.initial-count').attr('data-total');

    var brokersRemaining = parseInt(brokerCountRemaining.attr('data-return')) - parseInt(initialCount);
    brokerCountRemaining.attr('data-return', brokersRemaining);

    var nextOffset = parseInt(totalBrokers) - parseInt(brokerCountRemaining.attr('data-return'));
    jQuery('.view-more-button').attr('data-offset', nextOffset);


    if (brokerCountRemaining.attr('data-return') <= 0) {
        jQuery('.view-more-button').hide();
    }
}

function calculateRemain(element, id) {
    var exchangeModal = jQuery("#compare_exchange_modal");
    var exchangeForm =  jQuery(exchangeModal).find('.fn-sc--exchange-comparisons--form');
    var currentListId = jQuery('button[type="submit"]').attr('data-form-content');
    var currentList = jQuery(exchangeForm).find('.fn-sc--exchange-comparisons--list-' + currentListId);
    var checkedExchanges = jQuery(currentList).find('.fn-sc--exchange-comparisons--list__checkbox:checked').length;

    if (checkedExchanges >= 2) {
        jQuery(exchangeForm).find('button[type="submit"]').prop('disabled', false);
    }
    else if (checkedExchanges < 2) {
        jQuery(exchangeForm).find('button[type="submit"]').prop('disabled', true);
    }

    if (checkedExchanges > 5) {
        if (element) {
            jQuery(element).prop('checked', false);
            jQuery('.fn-sc--exchange-comparisons--list__checkbox[value="' + id + '"]').prop('checked', false);
        }
    }
    jQuery(exchangeModal).find('.js-selected-exchange-count').text(5 - checkedExchanges);
}

function resetExchangeChecklist() {
    var checkedExchanges = jQuery("#compare_exchange_modal .fn-sc--exchange-comparisons--form ").find('.fn-sc--exchange-comparisons--list__checkbox:checked');
    jQuery.each(checkedExchanges, function (key, val) {
        jQuery(val).prop('checked', false);
    });
}

// //Exchange Comparisons jQuery functions
function loadExchangeComparisonsFilterList() {
    //Counts & validates number of times a check box has been checked
    jQuery('body').on('change', '.fn-sc--exchange-comparisons--list__checkbox', function (e) {
        calculateRemain(e.target, jQuery(e.target).val());
        jQuery('.fn-sc--exchange-comparisons--list__checkbox[value="' + jQuery(e.target).val() + '"]').prop('checked', e.target.checked);
    });
//     //Submit handler for exchange comparisons form9
    jQuery('#compare_exchange_modal .fn-sc--exchange-comparisons--form').unbind().on('submit', function (e) {
        e.preventDefault();

        //Number of checked checboxes
        var currentListId = jQuery('button[type="submit"]').attr('data-form-content');
        var currentList = jQuery(this).find('.fn-sc--exchange-comparisons--list-' + currentListId);
        var checkedExchanges = jQuery(currentList).find('input[name="exchanges[]"]:checked');
        //Find error span and hide it
        var errorSpan = jQuery(this).closest('#compare_exchange_modal').find('.error');
        jQuery(errorSpan).hide();
        //Show error if more than 5 checkboxes have been checked or if none.
        if (checkedExchanges.length > 5 || checkedExchanges.length === 0) {
            //Set error message
            jQuery(errorSpan).text('Select up to 5 exchanges to compare').fadeIn();
            //Scroll to error message
            jQuery(this).closest("#compare_exchange_modal").animate({
                scrollTop: jQuery(errorSpan).offset().top
            }, 800);
            return false;
        }
        //Initialise array or Ids
        var exchangesIdArray = [];
        //Loop checked exchanges
        for (var i = 0; i < checkedExchanges.length; i++) {
            //Add id to array
            exchangesIdArray.push(jQuery(checkedExchanges[i]).val());
        }
        //Convert id array to string with '-' to seperate
        var exchanges = exchangesIdArray.join('-');
        //Set hidden input value
        jQuery(currentList).find('input[name="exchanges_list"]').val(exchanges);
        //Disable exchanges checkboxes inputs
        jQuery(currentList).find('input[name="exchanges[]"]').attr('disabled', true);

        loadingSpinner('show');

        jQuery('#compare_exchange_modal button[type="submit"]').attr('disabled', true);
        jQuery('#compare_exchange_modal').addClass('form-submitted');
        loadExchangeComparisonsTable(jQuery(this), exchanges);

        jQuery(this).addClass('submitted');
    });

    jQuery('#compare_exchange_modal_results').on('hidden.bs.modal', function () {
        jQuery('.modal-backdrop').remove();
        jQuery("html, body").removeClass('hide-scroll-vertical').addClass('show-scroll-vertical');
        resetExchangeChecklist();
        jQuery('.fn-sc--exchange-comparisons--list__checkbox').attr('disabled', false);
        jQuery('#compare_exchange_modal').removeClass('form-submitted');
    });

    jQuery('#compare_exchange_modal').on('hidden.bs.modal', function () {
        loadingSpinner('hide');
        if (jQuery('#compare_exchange_modal').hasClass('form-submitted')) {
            jQuery('#compare_exchange_modal_results').modal('show');
            resetExchangeChecklist();
            calculateRemain();
        }
    });
}

function loadExchangeComparisonsTable(form, exchanges) {
    var exchangeType = jQuery(form).find('#exchange_type').val();
    var showFixedCta = jQuery(form).find('input[name="show_fixed_cta"]').val();
    var fixedCtaUrlLeft = jQuery(form).find('input[name="fixed_cta_url_left"]').val();
    var fixedCtaImageUrlLeft = jQuery(form).find('input[name="fixed_cta_image_url_left"]').val();
    var fixedCtaUrlRight = jQuery(form).find('input[name="fixed_cta_url_right"]').val();
    var fixedCtaLabelRight = jQuery(form).find('input[name="fixed_cta_label_right"]').val();

    //Wordpress ajax hook action
    var data = {
        'action': 'get_comparison_table',
        'comparison_table': true,
        'exchanges_list': exchanges,
        'exchange_type': exchangeType,
        'show_fixed_cta': showFixedCta,
        'fixed_cta_url_left': fixedCtaUrlLeft,
        'fixed_cta_image_url_left': fixedCtaImageUrlLeft,
        'fixed_cta_image_url_right': fixedCtaUrlRight,
        'fixed_cta_label_right': fixedCtaLabelRight,
    };

    //Ajax Post request
    var ajaxRequest = jQuery.ajax({
        method: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: data,
        dataType: 'json'
    });
    ajaxRequest.fail(function(e) {
        showResultsTableError();
    });
    ajaxRequest.done(function (response) {
        if (response.status !== 'ok'){
            showResultsTableError();
            return false;
        }
        //Response
        jQuery('#compare_exchange_modal').modal('hide');

        jQuery('#compare_exchange_modal_results').modal('show');
        jQuery('#compare_exchange_modal_results .js-exchange-comparisons-results').html(response.data);

        jQuery('html, body').removeClass('show-scroll-vertical').addClass('hide-scroll-vertical');

        loadingSpinner('hide');

        /** Sticky Column header for the exchange comparisons table */
        jQuery('.fn-sc--exchange-comparisons--results--table').one('scroll', function() {
            var windowTop = jQuery('.fn-sc--exchange-comparisons--results--table').scrollTop();
            setListHeights();
        });
    });
}

function loadingSpinner(action) {
    if (action === 'show') {
        jQuery('#compare_exchange_modal').find('.exchange-comparisons-loading-spinner').removeClass('hide').addClass('show');
    }
    else {
        jQuery('#compare_exchange_modal').find('.exchange-comparisons-loading-spinner').removeClass('show').addClass('hide');
    }
}

function showResultsTableError() {
    //Hide loading spinner
    loadingSpinner('hide');
    //Show filter list form
    jQuery('#compare_exchange_modal').find('.fn-sc--exchange-comparisons--list .error').text("Error loading your results.").fadeIn();
    jQuery('#compare_exchange_modal').find('.fn-sc--exchange-comparisons--list').show();
    resetExchangeChecklist();
    calculateRemain();
}

function setListHeights() {
    /** Set span heights for all rows */
    var listCount = jQuery('.js-exchange-comparisons-results .js-table-column ul li').length;
    console.log(listCount);
    for (var i = 1;i<listCount;i++) {
        calculateListHeights(jQuery('.js-exchange-comparisons-results .js-table-column ul li[data-list-id="' + i + '"]'));
    }
}

//Calculates highest span height in an array
function calculateListHeights(listItems) {
    if(jQuery(listItems).length > 0) {
        jQuery.each(listItems, function (key, val) {
            var heights = [];
            for (var i = 0; i < listItems.length; i++) {
                //Get height of array and add to heights array
                var spanHeight = jQuery(listItems[i]).find('span').height();
                heights.push(spanHeight);
            }
            //calculate and return highest number in array
            var getRowHeight = Math.max.apply(null, heights);
            jQuery(val).find('span:last-child').height(getRowHeight);
        });
    }
}

jQuery(document).ready(function() {
    jQuery('.js-exchange-comparisons-filter').on('click', function() {
        var selectedFilter = jQuery(this).attr('data-filter-type');

        jQuery('.js-exchange-comparisons-filter').removeClass('selected');
        jQuery(this).addClass('selected');

        jQuery('.fn-sc--exchange-comparisons--list-list').hide();
        jQuery('.fn-sc--exchange-comparisons--list-' + selectedFilter).show();

        jQuery('.comparison-form-submit').attr('data-form-content', selectedFilter);
    });

    if (jQuery('.fn-sc--exchange-comparisons--modal').length > 0) {
        loadExchangeComparisonsFilterList();
    }
});
function comparisonColumns() {
	
    var swiper_comparisonColumns = new Swiper ('.js-comparisonColumn', {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        loop: true,
        // Responsive breakpoints
        breakpointsInverse: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 0,
                loop: false,
            }
        }
    });
}

function equalHeightColumns(){
    var maxHeight = 0;
    var slider = jQuery(".js-comparisonColumn .swiper-slide");

    slider.each(function(){
        if (jQuery(this).height() > maxHeight) { maxHeight = jQuery(this).height(); }
    });

    slider.height(maxHeight);
}

jQuery(window).resize( function() {
	if( jQuery('.js-comparisonColumn').length ) {
		comparisonColumns();
		equalHeightColumns();
	}
});

jQuery(document).ready(function(jQuery) {
	
    if( jQuery('.js-comparisonColumn').length ) {
		comparisonColumns();
		equalHeightColumns();
	}

	jQuery('#gotop').on('click',function(e) {
		e.preventDefault();
        jQuery('html, body').animate(
				{scrollTop : 0},500
				);
        return false;
    });

	// Select and loop the container element of the elements you want to equalise
    jQuery('.post-item-list').each(function(){  
    
		// Cache the highest
		var highestBox = 0;
		
		// Select and loop the elements you want to equalise
		jQuery('.post-details2 .eqheight', this).each(function(){
			
			// If this box is higher than the cached highest then store it
			if(jQuery(this).height() > highestBox) {
			highestBox = jQuery(this).height(); 
			}
		
		});  
				
		// Set the height of all those children to whichever was highest 
		jQuery('.post-details2 .eqheight',this).height(highestBox);
						
	}); 

	jQuery('.sc_fs_faq h2,.sc_fs_faq h3, .sc_fs_faq h4').on('click',function(e) {

		var jQuerythis = jQuery(this);
		
		if ( jQuery(this).closest('.sc_fs_faq').hasClass('show') ) {
			jQuery(this).closest('.sc_fs_faq').removeClass('show');
		} else {
			jQuery('.sc_fs_faq').removeClass('show');
			jQuery(this).closest('.sc_fs_faq').addClass('show');
		}
		
		e.preventDefault();
    });

	var cookie_reject_text = jQuery('#reject_button_text').val();
	jQuery('.pea_cook_wrapper p button').wrap('<div class="cookie-buttons"></div>');
	var ph = jQuery('.pea_cook_wrapper p').height() / 2;
	jQuery('<button class="pea_cook_btn" id="pea_cook_btn_decline">'+ cookie_reject_text.toUpperCase()+'</button>').insertAfter('#pea_cook_btn');
    if( jQuery(window).width() > 767 ) {
		jQuery('.pea_cook_wrapper .cookie-buttons').css('top', ph - 6 + 'px');
	}
	jQuery(window).resize(function(){
		var ph = jQuery('.pea_cook_wrapper p').height() / 2;
		if( jQuery(window).width() > 767 ) {
			jQuery('.pea_cook_wrapper .cookie-buttons').css('top', ph - 6 + 'px');
		}
	});
	jQuery(document).on('click','#pea_cook_btn_decline',()=>{
        jQuery('.pea_cook_wrapper').css('display','none');
        // document.cookie = "euCookie=reject; expires=Tue, 31 Dec 2030 12:00:00 UTC";
    })
	
	jQuery('#commentform').submit(function() {
		if ( jQuery.trim(jQuery("#author").val()) === "" || jQuery.trim(jQuery("#email").val()) === "" || jQuery.trim(jQuery("#comment").val()) === "" || !jQuery('input[name="wp-comment-cookies-consent"]:checked') ) {
			
			if ( jQuery.trim(jQuery("#author").val()) === "" ) {
				jQuery("#author").addClass('error');
			} else {
				jQuery("#author").removeClass('error');
			}
			if ( jQuery.trim(jQuery("#email").val()) === "" ) {
				jQuery("#email").addClass('error');
			} else {
				jQuery("#email").removeClass('error');
			}
			if ( jQuery.trim(jQuery("#comment").val()) === "" ) {
				jQuery("#comment").addClass('error');
			} else {
				jQuery("#comment").removeClass('error');
			}

			if(jQuery('input[name="wp-comment-cookies-consent"]').is(':checked'))
			{
				jQuery('input[name="wp-comment-cookies-consent"]').parent().removeClass('error');
			} else {
				jQuery('input[name="wp-comment-cookies-consent"]').parent().addClass('error');
			}

			return false;
		}
	});
	

	if( jQuery('.colorSettings--cdf .c-Trusted--disclaimer').length ) {
		jQuery( '.colorSettings--cdf .d-md-block .c-Trusted--disclaimer' ).wrapInner( '<span class="disclaimer-ellipses"></span>' );

		var disclaimer = jQuery('.colorSettings--cdf .d-md-block .c-Trusted--disclaimer').text();
		var html = '<span class="disclaimer-tooltip">'+disclaimer+'</span>';

		jQuery('.colorSettings--cdf .d-md-block .c-Trusted--disclaimer').append(html);
		jQuery('.c-FloatingPrompt--container .c-Trusted > .row.h-100').append('<div class="outer-disclaimer-icon-mbl">' + disclaimer + '</div>');
	
	}
	
}); 

document.addEventListener('DOMContentLoaded', function() {
    // Rating slider update
    const ratingSlider = document.querySelector('input[name="rating"]');
    const ratingValue = document.querySelector('.rating-value');
    
    if (ratingSlider) {
        ratingSlider.addEventListener('input', function() {
            ratingValue.textContent = `Current: jQuery{this.value}/5`;
        });
    }
});

// Add this to the existing AJAX code
document.querySelectorAll('.sort-select').forEach(select => {
    select.addEventListener('change', function() {
        document.querySelector('.apply-filters').click();
    });
});

// Initialize count on load
document.addEventListener('DOMContentLoaded', () => {
    updateFilterCount();
});

});